// extracted by mini-css-extract-plugin
module.exports = {"top":"styles_top__1vyrc","form":"styles_form__2xTeg"};